export default "__VITE_ASSET__C9aPjrIb__"